export { default as CreateProjectInTeamAuthFormSecondStepContent } from './CreateProjectInTeamAuthFormSecondStepContent';
